import { render, staticRenderFns } from "./CustomMultiselect.vue?vue&type=template&id=13e27fc7&scoped=true&"
import script from "./CustomMultiselect.vue?vue&type=script&lang=js&"
export * from "./CustomMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./CustomMultiselect.vue?vue&type=style&index=0&id=13e27fc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e27fc7",
  null
  
)

export default component.exports